/**
 * Created by uri.khaimov on 05/03/2017.
 */
import initialState from '../store/initialstate'
import C_HEADER from  '../constants/header';

export default (state = initialState().header, action = null) => {
    switch(action.type){
        case C_HEADER.SET_USER_LOGO:
            return state.set(C_HEADER.USER_LOGO, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/header.js